import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {scnv}           from "@Common/react/state-change-nested-value";

import {UploadModal} from "@Xpresso/routes/account/common/upload-card/upload-modal/upload-modal";

export const LogoUpload = ({logos, selectedLogos, agentId, next}) => cs(
    consumeContext("apis"),
    ["uploadModal", ({apis}, next) => UploadModal({
        title: "Logo",
        onUpload: async (data) => {
            const result = await apis.next.gallery.logos.upload({
                agentId,
                formData: {
                    file: data.file, name: data.name,
                    // defaultSlot: data.defaultSlot,
                },
            });
            if (result.errorMessage) {
                alert(result.errorMessage);
                return false;
            } else {
                if (data.defaultSlot) {
                    scnv(selectedLogos, ["current"], () => [result.printUrl]);
                }
                logos.change((_) => [..._??[], result]);
                return true;
            }
        },
        placeholder: "i.e. Logo Name",
        allowDefaultOption: false,
        next,
    })],
    ({uploadModal}) => next({
        show: uploadModal.show,
    }),
);

